// home-editor-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Adicionar bloco": "Agregar bloque",
    "Arraste para mudar a ordem das seções na Home do app. É necessário reabrir o App para visualizar as alterações.": "Arrastre para cambiar el orden de las secciones del Inicio de la app. Es necesario reabrir la app para ver los cambios.",
    "Arte recomendada: %{arg1} × %{arg2} px": "Arte recomendado: %{arg1} × %{arg2} px",
    "Arte recomendada: %{arg1} × %{arg2} px. O texto faz parte da imagem, então use a medida deste tipo — arte de outro formato fica distorcida ou ilegível.": "Arte recomendado: %{arg1} × %{arg2} px. El texto forma parte de la imagen, así que use la medida de este tipo: un arte de otro formato queda distorsionado o ilegible.",
    "Ação do toque": "Acción del toque",
    "Bloco de imagem — %{arg1}": "Bloque de imagen — %{arg1}",
    "Carrossel de banners": "Carrusel de banners",
    "Destino do toque": "Destino del toque",
    "Divide a linha com o próximo bloco de meia linha.": "Comparte la fila con el siguiente bloque de media fila.",
    "Editar bloco": "Editar bloque",
    "Escolha uma imagem para o bloco.": "Elija una imagen para el bloque.",
    "Escolher imagem": "Elegir imagen",
    "Esconder da Home": "Ocultar del Inicio",
    "Este bloco ainda não tem imagem e não vai aparecer no app": "Este bloque aún no tiene imagen y no aparecerá en la app",
    "Exibir apenas para os grupos": "Mostrar solo a los grupos",
    "Há bloco de imagem sem arte escolhida. Ele não aparece no app até receber uma imagem.": "Hay un bloque de imagen sin arte seleccionado. No aparece en la app hasta que reciba una imagen.",
    "Mensagem inicial": "Mensaje inicial",
    "Mostrar na Home": "Mostrar en el Inicio",
    "Nada visível na Home.": "Nada visible en el Inicio.",
    "Nenhuma imagem escolhida": "Ninguna imagen seleccionada",
    "Número de destino": "Número de destino",
    "Ocupa a largura toda da tela.": "Ocupa todo el ancho de la pantalla.",
    "Pagamentos pendentes": "Pagos pendientes",
    "Que tipo de bloco?": "¿Qué tipo de bloque?",
    "Remover bloco": "Eliminar bloque",
    "Saldo do cliente": "Saldo del cliente",
    "Salvar bloco": "Guardar bloque",
    "Sem grupo selecionado, o bloco aparece para todos os clientes.": "Sin grupo seleccionado, el bloque aparece para todos los clientes.",
    "Sem imagem": "Sin imagen",
    "Seções e blocos da Tela Inicial do App": "Secciones y bloques de la Pantalla de Inicio de la App",
    "URL de destino": "URL de destino",
    "Últimos abastecimentos": "Últimas cargas de combustible",
    "Últimos locais visitados": "Últimos lugares visitados",
    "Últimos produtos resgatados": "Últimos productos canjeados",
};

export default catalogo;
